import React from 'react'
import MaterialSymbol from '../material-symbol'

const ThreeP = React.forwardRef((props, ref) => (
  <MaterialSymbol ref={ref} name="3p" {...props} />
))

ThreeP.displayName = 'ThreeP'

export default ThreeP
